/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { AddressElement } from "@stripe/react-stripe-js";
import { StripeElementsProvider } from "@/components/stripe/stripe-elements-provider";
import configuration from "@/config/configuration";

const AddressForm = () => {
  return (
    <form>
      <AddressElement
        options={{
          mode: "billing",
          autocomplete: {
            mode: "google_maps_api",
            apiKey: configuration.google_maps_api_key,
          },
          fields: {
            phone: "always",
          },
          validation: {
            phone: {
              required: "always",
            },
          },
          display: {
            name: "split",
          },
        }}
      />
    </form>
  );
};

// X-3 (S711 review): the payment library now has one owner that can retry a
// failed load (lib/stripe-loader.ts); StripeElementsProvider reads it there.

const StripeAddress = () => {
  // PH-5 (S637): the same locale as the billing form. Two Elements contexts on
  // the same journey drawing their labels in two different languages is the
  // shape of defect this item is about.
  //
  // A-3 (S703): the shared provider. The flat appearance stays a parameter --
  // this block is styled differently on purpose, and folding that away would be
  // a visual change hidden inside a language fix.
  return (
    <StripeElementsProvider appearance={{ theme: "flat" }}>
      <AddressForm />
    </StripeElementsProvider>
  );
};

export default StripeAddress;
